import List from '@assets/icons/list.svg'
import { Icon } from './Icon'

export const ListIcon = Icon(List)
